import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatErrorMessage } from '../../utils';
import { notificationAlert } from '../notifications';
import { InvoicesKey } from './invoices.const';
import axios from 'axios';
import { apiEndpoints } from '../../constants/api';
import { Invoice } from './invoices.types';

export const fetchProjectInvoicesData = createAsyncThunk(
  `${InvoicesKey}/fetchProjectInvoicesData`,
  async (
    { accountId }: { accountId: string },
    thunkAPI,
  ): Promise<Invoice[]> => {
    try {
      const { data } = await axios.get(
        `${apiEndpoints.invoices(accountId)}`,
        {},
      );

      return data;
    } catch (err) {
      thunkAPI.dispatch(
        notificationAlert(
          formatErrorMessage(err, 'Fetching account invoices has failed'),
          {
            variant: 'error',
          },
        ),
      );
      throw new Error(String(err));
    }
  },
);
